module.exports = __webpack_public_path__ + "static/media/ecommerce.5cbbbc3f.png";